import styled, { css } from "styled-components"
import { centerContainer } from "./centerContainer.css"

export interface CenterContainerStyledProps {
  // 
}

export const CenterContainerStyled = styled.div<CenterContainerStyledProps>`
  ${centerContainer}
`